import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import NewTaskButton from '../Tasks/NewTaskButton';
import NewLeadButton from '../Leads/NewLeadButton';

const AddMenuButton: React.FC = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuClick = (type: 'task' | 'lead') => {
        handleClose();
        setTimeout(() => {
            if (type === 'task') {
                document.querySelector('[data-testid="new-task-button"]')?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            } else if (type === 'lead') {
                document.querySelector('[data-testid="new-lead-button"]')?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
        }, 100); // odroczone kliknięcie, by zamknąć menu
    };

    return (
        <>
            <IconButton
                aria-label="Dodaj"
                onClick={handleClick}
                size="large"
                sx={{ color: 'white' }}
            >
                <AddIcon />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem onClick={() => handleMenuClick('task')}>Nowe zadanie</MenuItem>
                <MenuItem onClick={() => handleMenuClick('lead')}>Nowy kontakt</MenuItem>
            </Menu>

            {/* Komponenty z ukrytym przyciskiem */}
            <div style={{ display: 'none' }}>
                <div data-testid="new-task-button-wrapper">
                    <NewTaskButton />
                </div>
                <div data-testid="new-lead-button-wrapper">
                    <NewLeadButton />
                </div>
            </div>
        </>
    );
};

export default AddMenuButton;
